import { gql } from "@apollo/client";

export const GET_WALLETS = gql`
  query GetWallets($filter: WalletFilterInput) {
    wallets(filter: $filter) {
      id
      name
      type
      status
      description
      userId
      balance
      currency
      createdAt
      updatedAt
    }
  }
`;

export const GET_WALLET = gql`
  query GetWallet($id: String!) {
    wallet(id: $id) {
      id
      name
      type
      status
      description
      userId
      balance
      currency
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_WALLET = gql`
  mutation CreateWallet($createWalletInput: CreateWalletInput!) {
    createWallet(createWalletInput: $createWalletInput) {
      id
      name
      type
      status
      description
      userId
      balance
      currency
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_WALLET = gql`
  mutation UpdateWallet($id: String!, $updateWalletInput: UpdateWalletInput!) {
    updateWallet(id: $id, updateWalletInput: $updateWalletInput) {
      id
      name
      type
      status
      description
      userId
      balance
      currency
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_WALLET = gql`
  mutation DeleteWallet($id: String!) {
    removeWallet(id: $id) {
      id
      name
    }
  }
`;

export const UPDATE_WALLET_BALANCE = gql`
  mutation UpdateWalletBalance($id: String!, $balance: Float!) {
    updateWalletBalance(id: $id, balance: $balance) {
      id
      name
      balance
      currency
    }
  }
`;

export const GET_WALLET_STATS = gql`
  query GetWalletStats($id: String!) {
    walletStats(id: $id) {
      wallet {
        id
        name
        type
        status
        description
        userId
        balance
        currency
        createdAt
        updatedAt
      }
      stats {
        totalTrades
        openPositions
        totalPositions
        currentBalance
      }
    }
  }
`;
